import React from 'react';
import { Popover as HeadlessPopover, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';

function Popover({
    elements,
    label,
    right = false,
    hideChevron = false,
}: {
    elements: React.ReactNode[];
    label: React.ReactNode;
    right: boolean;
    hideChevron?: boolean;
}) {
    const slideLeft = !right ? 'origin-bottom-left transform -translate-x-2/3' : '';
    return (
        <HeadlessPopover className="relative">
            {({ open }) => (
                <React.Fragment>
                    <HeadlessPopover.Button className="group inline-flex text-center px-2 py-1 justify-center items-center">
                        <span className="text-lg font-inter">{label}</span>
                        {!hideChevron && <ChevronDownIcon className="ml-2 h-6 w-6 mt-1" />}
                    </HeadlessPopover.Button>
                    <Transition
                        as={React.Fragment}
                        show={open}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <HeadlessPopover.Panel>
                            <div
                                className={`absolute z-50 mt-1 shadow-md bg-white border border-gray-050 p-3 rounded-sm flex-nowrap ${slideLeft}`}
                            >
                                {elements}
                            </div>
                        </HeadlessPopover.Panel>
                    </Transition>
                </React.Fragment>
            )}
        </HeadlessPopover>
    );
}

export { Popover };
